import styles from './FormBuilder.module.css'
import React, { useMemo, useContext } from 'react'

import { FormBuilderContext } from './store/store.FormBuilder'
import { observer } from 'mobx-react-lite'
import { toJS } from 'mobx'

// import of components
import Header from './components/Header/Header'
import NavBar from './components/NavBar/NavBar'
import SidebarEditor from './components/SidebarEditor/SidebarEditor'

import InnerHeader from './components/Body/InnerHeader/InnerHeader'
import InnerFooter from './components/Body/InnerFooter/InnerFooter'
import SidebarPage from './components/Body/SidebarPage/SidebarPage'
import Builder from './components/Body/Builder/Builder'

const FormBuilder = observer(() => {
  const storeFormBuilder = useContext(FormBuilderContext)

  return (
    <div className={styles.app}>
      <Header />

      <main className={styles.main}>
        <NavBar />
        {storeFormBuilder.isSidebarEditorOpen && <SidebarEditor />}

        <section className={styles.body}>
          <InnerHeader />
          <Builder />
          {storeFormBuilder.isSidebarPageOpen && <SidebarPage />}
          <InnerFooter />
        </section>
      </main>
    </div>
  )
})

export default FormBuilder
